(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sfm-kategorie-einleitung"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sfm-mehr-lesen')) {
    customElements.define('sfm-mehr-lesen', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const link = e.target.closest('a[href^="#"]');
          const ziel = link && document.getElementById(link.getAttribute('href').slice(1));
          if (!ziel) return;
          e.preventDefault();
          const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sfm-scroll-einblenden"] && !Shopify.designMode) return;
  try {
    class SfmScrollEinblenden extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.wartet = false;
      this.beimScrollen = () => {
        if (this.wartet) return;
        this.wartet = true;
        requestAnimationFrame(() => this.pruefen());
      };
      window.addEventListener('scroll', this.beimScrollen, { passive: true });
      window.addEventListener('resize', this.beimScrollen, { passive: true });
      this.pruefen();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.beimScrollen);
      window.removeEventListener('resize', this.beimScrollen);
    }

    pruefen() {
      this.wartet = false;
      const davor = this.section.previousElementSibling;
      const oben = this.section.getBoundingClientRect().top;
      const angeheftet = davor ? davor.getBoundingClientRect().bottom < oben - 1 : window.scrollY > 0;
      this.section.classList.toggle('sfm-ist-angeheftet', angeheftet);
    }
  }

  if (!customElements.get('sfm-scroll-einblenden')) {
    customElements.define('sfm-scroll-einblenden', SfmScrollEinblenden);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sfm-seitenhoehe"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sfm-seitenhoehe')) {
    customElements.define('sfm-seitenhoehe', class extends HTMLElement {
      connectedCallback() {
        const fuss = document.querySelector('.footer-group');
        if (!fuss || !window.ResizeObserver) return;
        this.beobachter = new ResizeObserver(() => {
          const hoehe = fuss.offsetHeight;
          if (hoehe === this.hoehe) return;
          this.hoehe = hoehe;
          document.documentElement.style.setProperty('--sfm-fusshoehe', hoehe + 'px');
          // Concepts Footer-Parallax misst seine Lage nur beim Laden und bei resize neu
          requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        });
        this.beobachter.observe(fuss);
        if (document.readyState !== 'complete') {
          window.addEventListener('load', () => window.dispatchEvent(new Event('resize')), { once: true });
        }
      }

      disconnectedCallback() {
        if (this.beobachter) this.beobachter.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sfm-uvp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sfm-uvp')) {
    customElements.define('sfm-uvp', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('hidden') === false) return; // Editor-Vorschau aus Liquid
        this.zeigen(Number(this.dataset.variante));
        const pubsub = window.theme && window.theme.pubsub;
        if (pubsub && pubsub.subscribe) {
          this.abmelden = pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, (e) => {
            const v = e && e.data && e.data.variant;
            if (v && String(e.data.productId) === this.dataset.produkt) this.zeigen(v.id);
          });
        }
      }

      disconnectedCallback() {
        if (typeof this.abmelden === 'function') this.abmelden();
      }

      async zeigen(varianteId) {
        try {
          this.daten = this.daten || fetch(this.dataset.url, { credentials: 'omit' }).then((r) => (r.ok ? r.json() : Promise.reject(r.status)));
          const produkt = await this.daten;
          const v = produkt.variants.find((x) => x.id === varianteId);
          if (!v) return this.setAttribute('hidden', '');
          const cent = v.compare_at_price > v.price ? v.compare_at_price : v.price;
          const format = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.dataset.waehrung });
          this.querySelector('.sfm-uvp__preis').textContent = format.format(cent / 100);
          this.removeAttribute('hidden');
        } catch (fehler) {
          this.daten = null;
          this.setAttribute('hidden', '');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
